import * as methods from '../methods';
import { Resource } from '../Resource';
export var MaizyState;
(function (MaizyState) {
    MaizyState[MaizyState["good"] = 0] = "good";
    MaizyState[MaizyState["medium"] = 1] = "medium";
    MaizyState[MaizyState["bad"] = 2] = "bad";
})(MaizyState || (MaizyState = {}));
const rootPath = 'oad/maizy';
export const getSoilTemperatureState = (pastState, futureState) => {
    const isFutureStateGood = futureState === MaizyState.good;
    const isPastStateGood = pastState === MaizyState.good;
    const isPastStateMedium = pastState === MaizyState.medium;
    const isFutureStateMedium = futureState === MaizyState.medium;
    if ([futureState, pastState].some((x) => x === null || typeof x === 'undefined'))
        return null;
    if (isPastStateGood && isFutureStateGood)
        return MaizyState.good;
    if ((isPastStateMedium && isFutureStateGood) ||
        (isPastStateMedium && isFutureStateMedium) ||
        (isPastStateGood && isFutureStateMedium))
        return MaizyState.medium;
    return MaizyState.bad;
};
export const fromRaw = {
    result: ({ parameters, data, dry_matter_target, seedling_date, flowering_range, harvest_range, flowering_date, calendar }) => ({
        daysWithoutRain: parameters?.days_without_rain,
        maxRainfallSum: parameters?.max_rainfall_sum,
        dryMatterTarget: dry_matter_target,
        seedlingDate: seedling_date,
        floweringRange: flowering_range,
        harvestRange: harvest_range,
        floweringDate: flowering_date,
        harvestingCalendar: calendar
            ? Object.entries(calendar).reduce((acc, [timestamp, { dry_matter, state, rain_state }]) => {
                acc[timestamp] = {
                    dryMatter: dry_matter,
                    state,
                    rainState: rain_state
                };
                return acc;
            }, {})
            : null,
        seedlingCalendar: data
            ? Object.entries(data).reduce((acc, [timestamp, { past_temperature, past_temperature_state, future_temperature, future_temperature_state, past_rain, past_rain_state, future_rain, future_rain_state, state }]) => {
                acc[timestamp] = {
                    pastTemperature: past_temperature,
                    pastTemperatureState: past_temperature_state,
                    futureTemperature: future_temperature,
                    futureTemperatureState: future_temperature_state,
                    pastRain: past_rain,
                    pastRainState: past_rain_state,
                    futureRain: future_rain,
                    futureRainState: future_rain_state,
                    soilTemperatureState: getSoilTemperatureState(past_temperature_state, future_temperature_state),
                    state
                };
                return acc;
            }, {})
            : null
    }),
    editConfig: ({ crop, dry_matter_target }) => ({
        cropId: crop,
        dryMatterTarget: dry_matter_target
    })
};
const toRaw = {
    editConfig: ({ cropId, dryMatterTarget }) => ({
        crop: cropId,
        dry_matter_target: dryMatterTarget
    })
};
const maizy = Resource((requesterBuilder) => {
    return {
        editConfig: methods.create({
            requesterBuilder,
            rootPath: `${rootPath}/config`,
            fromRaw: fromRaw.editConfig,
            toRaw: toRaw.editConfig
        }),
        result: (query) => methods.get({
            requesterBuilder,
            rootPath: `${rootPath}/result`,
            fromRaw: fromRaw.result,
            params: {
                query: {
                    crop: query?.cropId
                }
            }
        })()
    };
});
export default maizy;
